
import { Component, Vue } from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import draggable from 'vuedraggable'
import shoplist from '@/components/shoplist.vue'
import chooseCoupon from "@/components/chooseCoupon.vue"
import uploadImg from "@/components/upload-img.vue"
import { imgHost } from "@/utils/config"
import Message from '@/components/message.vue';
import ChoosePages from '@/components/choosepages/choosepages.vue';
import {
	activityWheelSurfactivityWheelSurfInfo,
	activityWheelSurfactivityWheelSurfSave
} from "@/api/live"
import {
	pagetypelist
} from "@/utils/config"
import {
	chooseLinkConvert,
	getDataConvert
} from "@/utils/index"
import previewImg from '@/components/previewImg.vue';
@Component({
	name: '',
	components: {
		PageFooter,
		draggable,
		shoplist,
		uploadImg,
		'slz-message': Message,
		previewImg,
		chooseCoupon,
		ChoosePages
	}
})

export default class ProductList extends Vue {
	private pageloading = false
	private imgHost = imgHost
	private form: any = {
		Id: 0,
		ActivityState: 0,
		Name: '',
		StartTime: '',
		EndTime: '',
		ActivityDescription: '',
		PrizeConfigList: [],
		ReceivePrizeTimeType: 1,
		ReceivePrizeStartTime: '',
		ReceivePrizeEndTime: '',
		ReceivePrizeDays: '',
		BackGroundImgUrl: [],
		IsCanShare: true,
		ShareContent: '',
		ShareImgUrl: [],
		NoLotteryChanceImageUrl: [],
		NoLotteryChanceRelationType: 0, // (int) = ['不关联:0' or '商品关联:1' or '商品分类:4' or '页面:5' or '系统页面:6' or '大转盘抽奖:7' or '签到活动:8' or '任务奖励活动:9' or '邀友有礼:10' or '小程序链接:11' or '直播:12' or '锦鲤抽奖:13']: 关联类型,
		NoLotteryChanceRelationTypeValue: '',
		NoLotteryChanceRelationValue: '',
		NoLotteryChanceRelationId: 0, // (int): 关联Id,
		NoLotteryChanceJumpPath: '', // (string, optional): 页面跳转路径,
		NoLotteryChanceIsJumpExternalWxApp: false, // (boolean): 是否跳转外部小程序--RelationType类型是小程序链接时使用,
		NoLotteryChanceExternalWxAppId: 0, // (string, optional): 外部小程序AppId--RelationType类型是小程序链接时使用,
		NoLotteryChanceExternalWxAppOriginalId: 0, // (string, optional): 外部小程序原始Id--RelationType类型是小程序链接时使用,
		NoLotteryChanceJumpPageName: '', // (string, optional): 跳转页面名称--RelationType类型是小程序链接时使用
	}
	private typelist = [
		{ value: 1, label: '实物' },
		{ value: 2, label: '红包' },
		{ value: 3, label: '空奖' },
		{ value: 4, label: '优惠券' },
	]
	private chooseShow = false;
	private couponList = [];
	private chooseShopShow = false
	private chooseShopList: any = []
	private current = 0
	private saveShow = false
	private preShow = false
	private currentUrl = 'http://routuan2022.oss-cn-hangzhou.aliyuncs.com/routuan/image/b4bbe7470b557704b7c0de93d7bf267.png'

	private show = false
	private choosemsg: any = {}

	private mounted() {
		if (Number(this.$route.query.Id)) {
			this.getInfo()
		}
	}


	private lookImg(img) {
		this.currentUrl = img
		this.preShow = true
	}
	private getconfiglist(e) {
		// console.log(this.form.PrizeConfigList)
	}
	private async getInfo() {
		try {
			this.pageloading = true
			let res: any = await activityWheelSurfactivityWheelSurfInfo({
				ActivityWheelSurfId: this.$route.query.Id
			})
			if (res.IsSuccess) {
				let form = res.Result
				for (let item of form.PrizeConfigList) {
					item.PrizeImgUrl = [item.PrizeImgUrl]
					item.WinningPrizeImgUrl = [item.WinningPrizeImgUrl]
					if (item.PrizeType == 1) {
						item.shopMsg = {
							Id: item.ProductId,
							ProductName: item.ProductName
						}
						item.RewardMoney = ''
					} else {
						item.shopMsg = {}
					}
					item.WinedPrizeCount = item.WinedPrizeCount || '/';
				}
				
				form.ShareImgUrl = form.ShareImgUrl ? [form.ShareImgUrl] : []
				form.BackGroundImgUrl = [form.BackGroundImgUrl]
				if (form.NoLotteryChanceImageUrl) {
					form.NoLotteryChanceImageUrl = [form.NoLotteryChanceImageUrl]
				} else {
					form.NoLotteryChanceImageUrl = []
				}
				if (this.$route.query.IsCopy == 'true') {
					form.Id = 0
					form.ActivityState = 0
				}
				this.form = form
			}
		} finally {
			this.pageloading = false
		}
	}
	private tosave() {
		let two = /^\d+(\.\d{1,2})?$/
		let one = /^\d+(\.\d{1})?$/
		if (!this.form.Name) {
			this.$message.error('请输入活动名称')
			return
		}
		if (!this.form.StartTime || !this.form.EndTime) {
			this.$message.error('请完善活动时间')
			return
		}
		if (new Date(this.form.StartTime).getTime() > new Date(this.form.EndTime).getTime()) {
			this.$message.error('开始时间不能晚于结束时间')
			return
		}
		if (!this.form.ActivityDescription) {
			this.$message.error('请填写活动说明，方便用户更好了解活动细则')
			return
		}
		if (!this.form.PrizeConfigList || this.form.PrizeConfigList.length < 2 || this.form.PrizeConfigList.length > 8) {
			this.$message.error('请设置2~8个奖项')
			return
		}
		let chance = 0
		// let hasinfinite = false
		for (let item of this.form.PrizeConfigList) {
			if (!item.PrizeName) {
				this.$message.error('请输入奖品名称')
				return
			}
			if (item.PrizeType == 1) {
				if (!item.ProductId) {
					this.$message.error('请设置实物奖品')
					return
				}
			} else if (item.PrizeType == 2) {
				if (!item.RewardMoney || item.RewardMoney < 0.01) {
					this.$message.error('请设置红包金额')
					return
				}
				if (!two.test(item.RewardMoney)) {
					this.$message.error('输入0.01~100000的数值')
					return
				}
				if (item.RewardMoney > 100000) {
					this.$message.error('红包金额最高10万')
					return
				}
			}
			if (!item.PrizeImgUrl || !item.PrizeImgUrl.length) {
				this.$message.error('请上传奖品图')
				return
			}
			if (!item.WinningPrizeImgUrl || !item.WinningPrizeImgUrl.length) {
				this.$message.error('请上传中奖图')
				return
			}
			if (!item.PrizeCount && String(item.PrizeCount) !== '0') {
				this.$message.error('请设置奖品数量')
				return
			}
			if (item.PrizeCount < 0 || item.PrizeCount != parseInt(item.PrizeCount)) {
				this.$message.error('请输入0~1000000的整数')
				return
			}
			if (item.PrizeCount > 1000000) {
				this.$message.error('单个奖品数量最大100万')
				return
			}
			// if(String(item.PrizeCount)==='0'){
			//   hasinfinite = true
			// }
			// console.log(item.PrizeOdds,!item.PrizeOdds)
			if (!item.PrizeOdds && String(item.PrizeOdds) != '0') {
				this.$message.error('请设置中奖概率')
				return
			}
			if (item.PrizeOdds < 0 || item.PrizeOdds > 100 || !one.test(item.PrizeOdds)) {
				this.$message.error('请输入0~100的数值，最多1位小数')
				return
			}
			chance += item.PrizeOdds * 10
		}
		// if(!hasinfinite){
		//   this.$message.error('至少有一个奖项的数量必须设置为0(表示无限制数量)')
		//   return 
		// }
		if (chance / 10 != 100) {
			this.$message.error('所有奖项中奖率之和≠100，请检查')
			return
		}

		if (this.form.ReceivePrizeTimeType == 1) {
			if (!this.form.ReceivePrizeStartTime || !this.form.ReceivePrizeEndTime) {
				this.$message.error('请完善兑奖时间')
				return
			}
			if (new Date(this.form.ReceivePrizeStartTime).getTime() > new Date(this.form.ReceivePrizeEndTime).getTime()) {
				this.$message.error('开始时间不能晚于结束时间')
				return
			}
		} else {
			if (!this.form.ReceivePrizeDays || this.form.ReceivePrizeDays < 1 || this.form.ReceivePrizeDays > 9999) {
				this.$message.error('使用期限允许1~9999天')
				return
			}
		}

		if (!this.form.BackGroundImgUrl || !this.form.BackGroundImgUrl.length) {
			this.$message.error('请上传抽奖页面背景图')
			return
		}
		if (this.form.IsCanShare) {
			if (!this.form.ShareContent) {
				this.$message.error('请设置分享文案')
				return
			}
			if (!this.form.ShareImgUrl || !this.form.ShareImgUrl.length) {
				this.$message.error('请上传分享图片')
				return
			}
		}
		this.saveShow = true
	}
	private async confirmSave() {
		try {
			this.saveShow = false
			this.pageloading = true
			let form = JSON.parse(JSON.stringify(this.form))
			form.PrizeConfigList = form.PrizeConfigList.map((item, i) => {
				item.Sort = i + 1
				if (item.PrizeType == 1) {
					item.RewardMoney = ''
				} else if (item.PrizeType == 2) {
					item.ProductId = ''
					item.ProductName = ''
				} else {
					item.ProductId = ''
					item.ProductName = ''
					item.RewardMoney = ''
				}
				item.PrizeImgUrl = item.PrizeImgUrl[0]
				item.WinningPrizeImgUrl = item.WinningPrizeImgUrl[0]
				item.shopMsg = undefined
				return item
			})
			form.BackGroundImgUrl = form.BackGroundImgUrl[0]
			form.NoLotteryChanceImageUrl = form.NoLotteryChanceImageUrl[0] || '';
			if (form.ReceivePrizeTimeType == 1) {
				form.ReceivePrizeDays = ''
			} else {
				form.ReceivePrizeStartTime = ''
				form.ReceivePrizeEndTime = ''
			}
			if (!form.IsCanShare) {
				form.ShareContent = ''
				form.ShareImgUrl = ''
			} else {
				form.ShareImgUrl = form.ShareImgUrl[0]
			}

			let res: any = await activityWheelSurfactivityWheelSurfSave({ ActivityWheelSurfInfo: form })
			if (res.IsSuccess) {
				this.$message.success('保存成功')
				this.$router.go(-1)
			}
		} finally {
			this.pageloading = false
		}
	}
	private uploadSuc2(file, key) {
		this.form[key] = file
	}
	private delprize(i) {
		this.form.PrizeConfigList.splice(i, 1)
	}
	private uploadSuc(file, name, i, key) {
		// console.log(file,name,i,key)
		this.form.PrizeConfigList[i][key] = file
	}
	private getshop(list) {
		// console.log(list)
		if (!list || !list.length) {
			this.$message.error('请选择商品')
			return
		}
		this.form.PrizeConfigList[this.current].shopMsg = list[0]
		this.form.PrizeConfigList[this.current].ProductId = list[0].Id
		this.form.PrizeConfigList[this.current].ProductName = list[0].ProductName
		// console.log(list[0])
		this.chooseShopShow = false
	}
	private setprize(v, i) {
		this.current = i
		this.chooseShopList = v.shopMsg.Id ? [v.shopMsg] : []
		this.chooseShopShow = true
	}
	private showCouponPop(v, i) {
		this.current = i
		this.couponList = v.CouponId ? [{ Id: v.CouponId, CouponName: v.CouponName }] : []
		this.chooseShow = true
	}
	private getData(list) {
		if (!list || !list.length) {
			this.$message.error('请选择优惠券')
			return
		}
		this.form.PrizeConfigList[this.current].CouponId = list[0].Id
		this.form.PrizeConfigList[this.current].CouponName = list[0].CouponName
		this.chooseShow = false
	}
	private addprize() {
		if (this.form.PrizeConfigList && this.form.PrizeConfigList.length >= 8) {
			this.$message.error('最多添加8个奖品')
			return
		}
		this.form.PrizeConfigList.push({
			Id: 0,
			Sort: 0,
			PrizeType: 1,
			PrizeName: '',
			ProductId: 0,
			shopMsg: {},
			RewardMoney: '',
			PrizeImgUrl: [],
			WinningPrizeImgUrl: [],
			PrizeCount: '',
			PrizeOdds: '',
			WinedPrizeCount: '/',
			UseRuleInstruction: '',
			CouponId: '',
			CouponName: ''
		})
	}

	private getLinkData(e) {
		console.log(e)
		this.choosemsg = e
		this.form.NoLotteryChanceRelationType = getDataConvert(e.pagetype, e.subdivideType);
		this.form.NoLotteryChanceRelationTypeValue = e.pagetypelabel;
		this.form.NoLotteryChanceRelationValue = e.label;
		this.form.NoLotteryChanceJumpPath = e.pageurl;
		this.form.NoLotteryChanceRelationId = e.Id;
		this.form.NoLotteryChanceIsJumpExternalWxApp = e.IsJumpExternalWxApp;
		this.form.NoLotteryChanceExternalWxAppId = e.ExternalWxAppId;
		this.form.NoLotteryChanceExternalWxAppOriginalId = e.ExternalWxAppOriginalId;
		this.form.NoLotteryChanceJumpPageName = e.label;
		// console.log(this.form.JumpPageName,'e')
		this.show = false
	}
	private choosepage() {
		this.show = true
		this.choosemsg = {
			...chooseLinkConvert(this.form.NoLotteryChanceRelationType),
			pagetypelabel: this.form.NoLotteryChanceRelationTypeValue,
			label: this.form.NoLotteryChanceRelationValue,
			pageurl: this.form.NoLotteryChanceJumpPath,
			Id: this.form.NoLotteryChanceRelationId,
			IsJumpExternalWxApp: this.form.NoLotteryChanceIsJumpExternalWxApp,
			ExternalWxAppId: this.form.NoLotteryChanceExternalWxAppId,
			ExternalWxAppOriginalId: this.form.NoLotteryChanceExternalWxAppOriginalId,
			JumpPageName: this.form.NoLotteryChanceRelationValue,
			JumpPath: this.form.NoLotteryChanceJumpPath
		}
		
	}
	private clear() {
		this.choosemsg = {}
		this.form.NoLotteryChanceRelationType = '';
		this.form.NoLotteryChanceRelationTypeValue = '';
		this.form.NoLotteryChanceRelationValue = '';
		this.form.NoLotteryChanceJumpPath = '';
		this.form.NoLotteryChanceRelationId = '';
		this.form.NoLotteryChanceIsJumpExternalWxApp = '';
		this.form.NoLotteryChanceExternalWxAppId = '';
		this.form.NoLotteryChanceExternalWxAppOriginalId = '';
		this.form.NoLotteryChanceJumpPageName = '';
	}
}
